import { _axios } from '../plugins/axios'
import Configuration from '@/configuration'
import i18next from 'i18next'
import authService from './external.auth.service'

const Vue = {}
Vue.axios = _axios

const getTokenId = () => {
  return authService.getUser().then((user) => {
    if (!user || (user && user.expired)) {
      authService.signinSilentCallback()
      return
    }
    return user.id_token
  })
}

export default {
  getMoc(communityAbbreviation, mocId) {
    return getTokenId().then((token) => {
      return Vue.axios({
        method: 'get',
        url: Configuration.value('externalEndpoint').concat(`/api/moc/GetMoc/${communityAbbreviation}/${mocId}`),
        headers: {
          Authorization: `Bearer ${token}`
        }
      }).then((success) => success.data)
    })
  },
  async getMocSupportingLinks(mocId) {
    return getTokenId().then((token) => {
      return Vue.axios({
        method: 'get',
        url: Configuration.value('externalEndpoint').concat(`/api/SupportingLinks/${mocId}`),
        headers: {
          Authorization: `Bearer ${token}`
        }
      }).then((success) => success.data)
    })
  },
  async getMocSupportingDocs(mocId) {
    return getTokenId().then((token) => {
      return Vue.axios({
        method: 'get',
        url: Configuration.value('externalEndpoint').concat(`/api/SupportingDocuments/List?mocId=${mocId}`),
        headers: {
          Authorization: `Bearer ${token}`
        }
      }).then((success) => success.data)
    })
  },
  getDisplayNames(shortName) {
    const displayNames = JSON.parse(JSON.stringify(i18next.getResourceBundle('en')))

    return getTokenId().then((token) => {
      return Vue.axios({
        method: 'get',
        url: Configuration.value('externalEndpoint').concat(`/api/community/${shortName}/DisplayNames`),
        headers: {
          Authorization: `Bearer ${token}`
        }
      }).then((success) => {
        return { ...displayNames, ...success.data }
      })
    })
  },
  isOpenTextEnabled(shortName) {
    return getTokenId().then((token) => {
      return Vue.axios({
        method: 'get',
        url: Configuration.value('externalEndpoint').concat(`/api/community/${shortName}/IsOpenTextEnabled`),
        headers: {
          Authorization: `Bearer ${token}`
        }
      }).then((success) => success.data)
    })
  },
  async getAllTasksForMoc(mocId) {
    return getTokenId().then((token) => {
      return Vue.axios({
        method: 'get',
        url: Configuration.value('externalEndpoint').concat(`/api/Task/GetAllByMocId/${mocId}`),
        headers: {
          Authorization: `Bearer ${token}`
        }
      }).then((success) => success.data)
    })
  },
  getAllApprovals(mocId) {
    return getTokenId().then((token) => {
      return Vue.axios({
        method: 'get',
        url: Configuration.value('externalEndpoint').concat(`/api/Approval/GetAllApprovalsForMoc/${mocId}`),
        headers: {
          Authorization: `Bearer ${token}`
        }
      }).then((success) => success.data)
    })
  },
  getComments(mocId) {
    return getTokenId().then((token) => {
      return Vue.axios({
        method: 'get',
        url: Configuration.value('externalEndpoint').concat(`/api/comment?mocId=${mocId}`),
        headers: {
          Authorization: `Bearer ${token}`
        }
      }).then((success) => success.data)
    })
  },
  getUserProfile() {
    return authService.getUser().then((user) => ({
      email: user && user.profile ? user.profile.email : '',
      name: user && user.profile ? user.profile.name : ''
    }))
  },
  setApprovalDecision(mocId, approval) {
    return getTokenId().then((token) => {
      return Vue.axios({
        method: 'post',
        data: approval,
        url: Configuration.value('externalEndpoint').concat(`/api/approval/setapprovaldecision/${mocId}`),
        headers: {
          Authorization: `Bearer ${token}`
        }
      }).then((success) => success.data)
    })
  },
  async saveComment(mocId, comment = {}) {
    return getTokenId().then((token) => {
      return Vue.axios({
        method: 'post',
        data: {
          mocId: mocId,
          ...comment
        },
        url: Configuration.value('externalEndpoint').concat(`/api/Comment/${mocId}`),
        headers: {
          Authorization: `Bearer ${token}`
        }
      }).then((success) => success.data)
    })
  },
  async downloadSupportingDoc(mocId, fileName, version) {
    let url = Configuration.value('externalEndpoint').concat(`/api/SupportingDocuments/${mocId}`)

    return getTokenId().then((token) => {
      return Vue.axios({
        method: 'get',
        url: url,
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {
          mocId,
          fileName,
          version
        }
      }).then((success) => {
        return success.data
      })
    })
  }
}
